import { useQuery } from "@tanstack/react-query";
import { fetchPhotoSizes } from "src/api/photo-size.api";
import { GetPhotoSizeDto } from "src/services/generated-api";

export const photoSizesQueryKey = ["photo-sizes"] as const;

export function usePhotoSizes() {
  return useQuery<GetPhotoSizeDto[]>({
    queryKey: photoSizesQueryKey,
    queryFn: fetchPhotoSizes,
    staleTime: 5 * 60 * 1000,
  });
}
